import { render, staticRenderFns } from "./AudioBlockWaveform.vue?vue&type=template&id=0ffa0f04&scoped=true"
import script from "./AudioBlockWaveform.vue?vue&type=script&lang=js"
export * from "./AudioBlockWaveform.vue?vue&type=script&lang=js"
import style0 from "./AudioBlockWaveform.vue?vue&type=style&index=0&id=0ffa0f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa0f04",
  null
  
)

export default component.exports